import { PopUpMain } from "../../component/popUp";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { Box, Button, MenuItem, Skeleton, Stack } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import * as yup from "yup";
import { intialSteelData } from "./data";
import { AppDispatch } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { addUser, updateUser } from "../../api/admin/Api.service";
import titleCase from "../../utils/titleCase";

export function AddUser(props: any) {
  const { title = "Add Steel", open } = props;

  return (
    <Box>
      <PopUpMain title={title} {...props} size={"sm"} data-dc={1}>
        <Box>
          <AddSteelScreen {...props} />
        </Box>
      </PopUpMain>
    </Box>
  );
}

export interface StateStruct {
  state: string;
  abbrevation: string;
}

export const AddSteelScreen = (props: any): JSX.Element => {
  const { handleClose, editData, refreshSteel } = props;
  const { userEditData } = useSelector((state: any) => state.adminState);
  const { filterData } = useSelector((state: any) => state.adminState);
  const dispatch: AppDispatch = useDispatch();

  const validationSchema = yup.object({
    firstName: yup
      .string()
      .required("First Name Is Required")
      .test("len", "Must be less than 30 characters", (val) => {
        if (val === undefined) return true;
        return val.length === 0 || (val.length >= 1 && val.length <= 30);
      }),
    lastName: yup
      .string()
      .required("Last Name Is Required")
      .test("len", "Must be less than 30 characters", (val) => {
        if (val === undefined) return true;
        return val.length === 0 || (val.length >= 1 && val.length <= 30);
      }),
    emailId: yup
      .string()
      .required("Email Is Required")
      .email("Must be a valid Email Address"),
    // role: yup
    //   .string()
    //   .required("Role Is Required")
    //   .test("len", "Must be less than 30 characters", (val) => {
    //     if (val === undefined) return true;
    //     return val.length === 0 || (val.length >= 1 && val.length <= 30);
    //   }),
    // location: yup
    //   .string()
    //   .required("Location Is Required")
    //   .test("len", "Must be less than 30 characters", (val) => {
    //     if (val === undefined) return true;
    //     return val.length === 0 || (val.length >= 1 && val.length <= 30);
    //   }),
  });

  const handleCallBack = () => {
    refreshSteel();
    handleClose();
  };

  const handleChange = (event: any, fieldName: any, Name: any) => {
    let {
      target: { value },
    } = event;

    if (Name) fieldName(Name, value);
  };

  return (
    <React.Fragment>
      <>
        {false ? (
          <>
            <Box
              ml={0}
              sx={{
                p: 3,
                backgroundColor: "#fff ",
                height: "100%",
                ml: 0,
              }}
            >
              <Stack spacing={3}>
                {[...Array(11)].map(() => (
                  <Grid
                    sx={{
                      gap: "30px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    spacing={2}
                  >
                    <Skeleton
                      variant="rounded"
                      sx={{ height: "3", width: "50%" }}
                      animation={"wave"}
                    />
                    <Skeleton
                      variant="rounded"
                      sx={{ height: "3", width: "50%" }}
                      animation={"wave"}
                    />
                  </Grid>
                ))}
                <Grid
                  sx={{
                    gap: "30px",
                    display: "flex",
                    marginTop: "20px",
                    marginLeft: "20px",
                  }}
                  spacing={2}
                >
                  <Skeleton
                    variant="rounded"
                    sx={{ height: "6vh", width: "150px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    sx={{ height: "6vh", width: "150px" }}
                  />
                </Grid>
              </Stack>
            </Box>
          </>
        ) : (
          <Formik
            initialValues={
              editData?.id
                ? userEditData
                  ? userEditData
                  : intialSteelData
                : intialSteelData
            }
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              const data = {
                data: values,
                callback: handleCallBack,
              };
              if (editData?.id) {
                const updateData = {
                  data: { ...values },
                  callback: handleCallBack,
                };
                dispatch(updateUser(updateData));
              } else {
                dispatch(addUser(data));
              }
            }}
          >
            {({ resetForm, isSubmitting, setFieldValue }) => (
              <>
                <Box
                  ml={0}
                  sx={{
                    p: 3,
                    backgroundColor: "#fff ",
                  }}
                >
                  <Form>
                    <Grid container spacing={2.5}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Field
                          component={TextField}
                          id="firstName"
                          name="firstName"
                          size="small"
                          label="First Name"
                          fullWidth
                          variant="outlined"
                          onChange={(event: any) =>
                            handleChange(event, setFieldValue, `firstName`)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Field
                          component={TextField}
                          id="lastName"
                          name="lastName"
                          size="small"
                          label="Last Name"
                          fullWidth
                          variant="outlined"
                          onChange={(event: any) =>
                            handleChange(event, setFieldValue, `lastName`)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Field
                          component={TextField}
                          id="emailId"
                          name="emailId"
                          size="small"
                          label="Email Address"
                          disabled={editData?.id}
                          fullWidth
                          variant="outlined"
                          onChange={(event: any) =>
                            handleChange(event, setFieldValue, `emailId`)
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12}>
                        <Field
                          component={TextField}
                          select
                          id="roleId"
                          type="text"
                          name="roleId"
                          size="small"
                          label="Role"
                          fullWidth
                          variant="outlined"
                          onChange={(event: any) =>
                            handleChange(event, setFieldValue, `roleId`)
                          }
                        >
                          {filterData?.roles?.map((option: any, i: number) => (
                            // @ts-ignore
                            <MenuItem
                              key={Object.keys(option)[0]}
                              value={Object.keys(option)[0]}
                            >
                              {titleCase(Object.values(option)[0])}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Field
                          component={TextField}
                          select
                          id="locationId"
                          name="locationId"
                          type="text"
                          size="small"
                          label="Location"
                          fullWidth
                          variant="outlined"
                          onChange={(event: any) =>
                            handleChange(event, setFieldValue, `locationId`)
                          }
                        >
                          {filterData?.locations?.map(
                            (option: any, i: number) => (
                              // @ts-ignore
                              <MenuItem
                                key={Object.keys(option)[0]}
                                value={Object.keys(option)[0]}
                              >
                                {titleCase(Object.values(option)[0])}
                              </MenuItem>
                            )
                          )}
                        </Field>
                      </Grid>
                      {editData?.id && (
                        <Grid item xs={12} sm={12} md={12}>
                          <Field
                            component={TextField}
                            select
                            fullWidth
                            id={editData?.id ? "isActive" : "status"}
                            name={editData?.id ? "isActive" : "status"}
                            type="text"
                            size="small"
                            label="Status"
                            variant="outlined"
                            disabled={
                              !editData?.id ||
                              editData?.emailConfimationStatus === 0
                            }
                            onChange={(event: any) =>
                              handleChange(
                                event,
                                setFieldValue,
                                editData?.id ? "isActive" : "status"
                              )
                            }
                          >
                            <MenuItem value="1" key="active">
                              Active
                            </MenuItem>
                            <MenuItem value="0" key="inactive">
                              Inactive
                            </MenuItem>
                          </Field>
                        </Grid>
                      )}
                    </Grid>

                    <Box className="popupBtn" display={"flex"} gap={2} pt={2}>
                      <Button
                        variant="contained"
                        disabled={isSubmitting}
                        type="submit"
                      >
                        {"Save"}
                      </Button>
                      <Button onClick={handleClose} variant="outlined">
                        Cancel
                      </Button>
                      {editData?.id ? (
                        <></>
                      ) : (
                        <Button
                          variant="outlined"
                          color="error"
                          type="reset"
                          onClick={(e) => resetForm()}
                        >
                          Reset
                        </Button>
                      )}
                    </Box>
                  </Form>
                </Box>
              </>
            )}
          </Formik>
        )}
      </>
    </React.Fragment>
  );
};
